/**
 * Created by rybak on 10.09.2015.
 */
import * as _ from 'underscore';

// Variable edit components
import { FontField } from '../../../../_common/platform/ts/FontField';
import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField';
import SelectField from '../../../../_common/platform/ts/SelectField';

// Theme dispatcher module
import * as appTheme from '../../../../_common/platform/ts/appTheme';

// Any dependency themes, which should be initialized before this one
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';

// Preview React component
declare var require: any;
import { ThemePreview } from '../../tsx/ThemePreview';
import BooleanField from '../../../../_common/platform/ts/BooleanField';

// CSS template for the widget
var template = require('!!raw-loader!pdc-widget-kpi/src/mainTheme.template.css').default;

// A hack, to make sure that TS compiler will include this module as dependency in generated AMD
template;

// This array, which saves all glob objects, on which theme was initialized
// It's used to make sure that `init` is launched only once for each glob.
// Here, it's possible that platform will run init for widgetTheme more than 1 time.
var _init = [];

export function init(glob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    //LL: 20.10.17:
    const fontSizeValues = [
        'inherit',
        'smaller',
        'larger',
        'xx-small',
        'x-small',
        'small',
        'medium',
        'large',
        'x-large',
        'xx-large'
    ];
    const fontSizeDisplay = [
        'default',
        'smaller than default',
        'larger than default',
        'xx-small',
        'x-small',
        'small',
        'medium',
        'large',
        'x-large',
        'xx-large'
    ];

    // Init parent theme
    widgetTheme(glob);

    // Register section, which will be displayed on the left of theme edit component
    appTheme.registerSections([
        {
            id: 'widget-kpi',
            name: 'KPI',
            parent: 'widget',
            preview: ThemePreview,
            previewClassName: 'preview-widget preview-widget-kpi',

            themeType: 'Widget KPI',
            visibility: ['application', 'workspace', 'pdc-widget-kpi']
        }
    ]);

    appTheme.registerGroups([
        {
            id: 'kpi-label-font',
            name: 'KPI Label Font',

            section: 'widget-kpi'
        },
        {
            id: 'kpi-value-font',
            name: 'KPI Value Font',

            section: 'widget-kpi'
        }
    ]);

    // Register theme variables
    appTheme.registerVars([
        {
            id: 'widget-kpi-show-labels',
            param: new BooleanField(glob, 'Show Labels', [], true),
            section: 'widget-kpi'
        },

        {
            id: 'widget-kpi-labels-below',
            param: new BooleanField(glob, 'Labels under Values', [], false),
            section: 'widget-kpi'
        },

        {
            id: 'widget-kpi-label-color',
            param: new ColorBoxField(
                glob,
                'KPI Label Color',
                [],
                function (theme) {
                    return theme['gray-base'];
                },
                { hideTransparency: true }
            ),
            section: 'widget-kpi',
            deps: ['gray-base']
        },

        {
            id: 'widget-kpi-label-font',
            param: new FontField(
                glob,
                'Font Face',
                [],
                function (theme) {
                    return theme['widget-font'];
                },
                {}
            ),
            section: 'widget-kpi',
            group: 'kpi-label-font',
            deps: ['widget-font']
        },
        {
            id: 'widget-kpi-label-font-size',
            param: new SelectField(
                glob,
                'Font Size',
                [],
                function (theme) {
                    return theme['widget-font-size'];
                },
                {
                    values: [
                        'default',
                        'xx-small',
                        'x-small',
                        'small',
                        'medium',
                        'large',
                        'x-large',
                        'xx-large',
                        'smaller',
                        'larger'
                    ],
                    display: [
                        'default',
                        'xx-small',
                        'x-small',
                        'small',
                        'medium',
                        'large',
                        'x-large',
                        'xx-large',
                        'smaller',
                        'larger'
                    ]
                }
            ),
            section: 'widget-kpi',
            group: 'kpi-label-font',
            deps: ['widget-font-main']
        },
        {
            id: 'widget-kpi-label-font-weight',
            param: new SelectField(
                glob,
                'Font Weight',
                [],
                function (theme) {
                    return theme['widget-font-weight'];
                },
                {
                    values: ['lighter', 'normal', 'bold', 'bolder'],
                    display: ['lighter', 'normal', 'bold', 'bolder']
                }
            ),
            section: 'widget-kpi',
            group: 'kpi-label-font',
            deps: ['widget-font-weight']
        },
        {
            id: 'widget-kpi-label-font-italic',
            param: new BooleanField(glob, 'Italic', [], function (theme) {
                return theme['widget-font-italic'];
            }),
            section: 'widget-kpi',
            group: 'kpi-label-font',
            deps: ['widget-font-italic']
        },

        {
            id: 'widget-kpi-value-color',
            param: new ColorBoxField(
                glob,
                'KPI Value Color',
                [],
                function (theme) {
                    return theme['gray-base'];
                },
                { hideTransparency: true }
            ),
            section: 'widget-kpi',
            deps: ['gray-base']
        },

        {
            id: 'widget-kpi-value-font',
            param: new FontField(
                glob,
                'Font Face',
                [],
                function (theme) {
                    return theme['widget-font'];
                },
                {}
            ),
            section: 'widget-kpi',
            group: 'kpi-value-font',
            deps: ['widget-font']
        },
        {
            id: 'widget-kpi-value-font-size',
            param: new SelectField(
                glob,
                'Font Size',
                [],
                function (theme) {
                    return theme['widget-font-size'];
                },
                {
                    values: [
                        'default',
                        'xx-small',
                        'x-small',
                        'small',
                        'medium',
                        'large',
                        'x-large',
                        'xx-large',
                        'smaller',
                        'larger'
                    ],
                    display: [
                        'default',
                        'xx-small',
                        'x-small',
                        'small',
                        'medium',
                        'large',
                        'x-large',
                        'xx-large',
                        'smaller',
                        'larger'
                    ]
                }
            ),
            section: 'widget-kpi',
            group: 'kpi-value-font',
            deps: ['widget-font-main']
        },
        {
            id: 'widget-kpi-value-font-weight',
            param: new SelectField(
                glob,
                'Font Weight',
                [],
                function (theme) {
                    return theme['widget-font-weight'];
                },
                {
                    values: ['lighter', 'normal', 'bold', 'bolder'],
                    display: ['lighter', 'normal', 'bold', 'bolder']
                }
            ),
            section: 'widget-kpi',
            group: 'kpi-value-font',
            deps: ['widget-font-weight']
        },
        {
            id: 'widget-kpi-value-font-italic',
            param: new BooleanField(glob, 'Italic', [], function (theme) {
                return theme['widget-font-italic'];
            }),
            section: 'widget-kpi',
            group: 'kpi-value-font',
            deps: ['widget-font-italic']
        },

        {
            id: 'widget-kpi-alignment',
            param: new SelectField(glob, 'Alignment', [], 'not_used', {
                values: ['not_used', 'repeatVertically', 'repeatHorizontally'],
                display: ['Without Alignment', 'Vertical', 'Horizontal']
            }),
            section: 'widget-kpi'
        }
    ]);

    // Register templates
    appTheme.registerTemplate(template, ['pdc-widget-kpi']);

    _init.push(glob);
}
